import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'fullCaps'
})
export class FullCapsPipe implements PipeTransform {

  transform(str: string | undefined): string {
    if (!str) return '';
    return str.toUpperCase();
  }

}
